import React from 'react';

export const FilterButton = ({ onClick, ...props }) => {
  return (
    <button onClick={onClick} {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
      >
        <g id="Button Icon">
          <path
            id="Icon-filter"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.37577 3.33594L4.2623 3.34203C3.52197 3.42244 3.11349 4.28175 3.55881 4.91262L9.37577 13.1529V20.8359C9.37577 21.6951 10.3877 22.1543 11.0343 21.5885L15.0343 18.0885L15.1215 18.0022C15.2843 17.82 15.3758 17.5831 15.3758 17.3359V13.1509L21.1927 4.91262C21.6603 4.25021 21.1866 3.33594 20.3758 3.33594H4.37577ZM18.4458 5.33594L13.5588 12.2593L13.494 12.3642C13.4167 12.5088 13.3758 12.6707 13.3758 12.8359V16.8809L11.3758 18.6309V12.8359L11.3682 12.7129C11.348 12.5502 11.288 12.3942 11.1927 12.2593L6.30477 5.33594H18.4458Z"
            fill="#0054A4"
          />
        </g>
      </svg>
    </button>
  );
};

export const ActionButton = ({ onClick, className }) => {
  return (
    <button onClick={onClick} className={className || ''}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
      >
        <g id="Button Icon">
          <path
            id="Icon-Apps"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.37573 8.33594H8.37573V4.33594H4.37573V8.33594ZM10.3757 20.3359H14.3757V16.3359H10.3757V20.3359ZM4.37573 20.3359H8.37573V16.3359H4.37573V20.3359ZM4.37573 14.3359H8.37573V10.3359H4.37573V14.3359ZM10.3757 14.3359H14.3757V10.3359H10.3757V14.3359ZM16.3757 4.33594V8.33594H20.3757V4.33594H16.3757ZM10.3757 8.33594H14.3757V4.33594H10.3757V8.33594ZM16.3757 14.3359H20.3757V10.3359H16.3757V14.3359ZM16.3757 20.3359H20.3757V16.3359H16.3757V20.3359Z"
            fill="#0054A4"
          />
        </g>
      </svg>
    </button>
  );
};
